// ABOUTME: Read filters section of the object schema form: one row per filter, added and removed as a field array.
// ABOUTME: The values are the form's "readFilters"; the form's Save sends them through setObjectSchemaReadFilters.

import { AddIcon, Box, Button, Typography } from '@ds/coolshop';
import { SectionDivider } from '@src/_new/modules/product/components/ProductInfoViewer/FormComponent/components/SectionDivider';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { emptyDraft, ReadFilterDraft } from '../utils/readFilterDrafts';
import { ReadFilterRow } from './ReadFilterRow';

export function ReadFiltersFields({ objectSchemaId }: { objectSchemaId: string }): JSX.Element {
    const intl = useIntl();
    const { control } = useFormContext<{ readFilters: ReadFilterDraft[] }>();
    const { fields, append, remove } = useFieldArray({ control, name: 'readFilters' });

    return (
        <>
            <SectionDivider
                label={intl.formatMessage({
                    id: 'chip.read-filters',
                    defaultMessage: 'Read filters',
                })}
            />
            <Typography variant="body2" color="text.secondary">
                {intl.formatMessage({
                    id: 'read-filters.info',
                    defaultMessage:
                        'Neo4j predicates on n, ANDed into what every user reads on the hierarchies of this schema; they can only narrow it. Read-only Cypher; variables other than n need the v_ prefix; parameters: $roles, $company, $meNodeId, $myDealershipIds, $myClientIds, $activeMarketId, $allowedMarketIds and the package ones. Who bypasses a filter is up to the filter itself, through $roles. A filter shipped by the tenant package is restored by align when removed or changed. Use Explain to preview a filter before saving.',
                })}
            </Typography>
            {fields.map((field, index) => (
                <ReadFilterRow
                    key={field.id}
                    objectSchemaId={objectSchemaId}
                    index={index}
                    source={field.source}
                    onRemove={() => remove(index)}
                />
            ))}
            <Box>
                <Button variant="text" startIcon={<AddIcon />} onClick={() => append(emptyDraft())}>
                    {intl.formatMessage({
                        id: 'read-filters.add',
                        defaultMessage: 'Add filter',
                    })}
                </Button>
            </Box>
        </>
    );
}
